export default __webpack_public_path__ + "static/client-video-embed-placeholder-eb7ab5643478605c41f0ec2ce8315be2.webp";